export const transferHistoryEn = {
  // Page heading and titles
  'transfer-history-heading': 'Transfer History',
  'transfer-history-list-title': 'Transfer History',

  // Type filter options
  'transfer-history-type-all': 'All Types',
  'transfer-history-type-push': 'E-Transfer Push',
  'transfer-history-type-pull': 'E-Transfer Pull',
  'transfer-history-type-direct-send': 'Direct Send Transfer',
  'transfer-history-type-direct-send-pull': 'Direct Send Pull Transfer',
  'transfer-history-type-filter-label': 'Filter by type:',

  // Table headers
  'transfer-history-date-table-header': 'Date',
  'transfer-history-name-table-header': 'Account Name',
  'transfer-history-type-table-header': 'Type',
  'transfer-history-status-table-header': 'Status',
  'transfer-history-amount-table-header': 'Amount',
  'transfer-history-action-table-header': 'Action',

  // Info alerts
  'transfer-history-no-transfers-alert': 'No transfers found.',

  // Cancel transfer modal
  'transfer-history-cancel-heading': 'Cancel Transfer',
  'transfer-history-cancel-confirm-text':
    'Are you sure you want to cancel this transfer? This action cannot be undone.',
  'transfer-history-confirm-cancel-button': 'Yes, Cancel Transfer',
  'transfer-history-keep-button': 'No, Keep Transfer',
  'transfer-history-cancel-success-alert': 'Transfer cancelled successfully',
  'transfer-history-cancel-error-alert': 'Failed to cancel transfer. Please email Cardholder Support for more information.',
};

export const transferHistoryFr = {
  // Page heading and titles
  'transfer-history-heading': 'Historique des transferts',
  'transfer-history-list-title': 'Historique des transferts',

  // Type filter options
  'transfer-history-type-all': 'Tous les types',
  'transfer-history-type-push': 'Virement Interac sortant',
  'transfer-history-type-pull': 'Virement Interac entrant',
  'transfer-history-type-direct-send': 'Transfert direct',
  'transfer-history-type-direct-send-pull': 'Transfert direct entrant',
  'transfer-history-type-filter-label': 'Filtrer par type:',

  // Table headers
  'transfer-history-date-table-header': 'Date',
  'transfer-history-name-table-header': 'Nom du compte',
  'transfer-history-type-table-header': 'Type',
  'transfer-history-status-table-header': 'Statut',
  'transfer-history-amount-table-header': 'Montant',
  'transfer-history-action-table-header': 'Action',

  // Info alerts
  'transfer-history-no-transfers-alert': 'Aucun transfert trouvé.',

  // Cancel transfer modal
  'transfer-history-cancel-heading': 'Annuler le transfert',
  'transfer-history-cancel-confirm-text':
    'Êtes-vous sûr de vouloir annuler ce transfert? Cette action est irréversible.',
  'transfer-history-confirm-cancel-button': 'Oui, annuler le transfert',
  'transfer-history-keep-button': 'Non, conserver le transfert',
  'transfer-history-cancel-success-alert': 'Transfert annulé avec succès',
  'transfer-history-cancel-error-alert': 'Échec de l\'annulation du transfert. Veuillez envoyer un courriel au service d\'assistance aux titulaires de carte pour plus d\'informations.',
};
